export class MediaAxios {
  static getImageUrl(imageId: string) {
    return `${process.env.REACT_APP_API_URL}/media/${imageId}`;
  }
}
